import type { Movie } from '@/types/movie';

export const movies: Movie[] = [
  {
    id: 'm-001',
    title: '午夜电台',
    year: 2024,
    duration: 118,
    category: '悬疑',
    tags: ['都市', '电台', '追凶'],
    director: '沈墨',
    cast: ['林时序', '苏未晞', '程野'],
    rating: 8.7,
    synopsis: '深夜电台主播接到一通自称来自三天后的电话，电话里预告了第二天的命案。她必须在直播结束前找到那个还没死去的人。',
    midnightReason: '耳机里的电流声与凌晨的安静绝配，越听越冷，越冷越清醒。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20lone%20radio%20host%20in%20a%20dark%20studio%2C%20deep%20navy%20and%20crimson%20tones%2C%20moody%20midnight%20atmosphere%2C%20dramatic%20rim%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-001&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20empty%20late%20night%20radio%20studio%2C%20glowing%20red%20on%20air%20sign%2C%20deep%20navy%20shadows%2C%20moody%20atmospheric%20lighting%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-001&orientation=landscape',
    views: 128400,
    favorites: 9420,
    featured: true,
  },
  {
    id: 'm-002',
    title: '第七层楼道',
    year: 2023,
    duration: 104,
    category: '恐怖',
    tags: ['公寓', '灵异', '密室'],
    director: '白峒',
    cast: ['周未然', '许听澜', '高聿'],
    rating: 8.2,
    synopsis: '一栋老公寓的电梯永远停不到第七层，直到一位夜班保安决定走楼梯上去，同事告诉他：上去的人从没下来过。',
    midnightReason: '独自在家看片时，隔壁电梯“叮”的一声，你会本能地回头。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20poster%20of%20a%20dim%20apartment%20stairwell%20at%20night%2C%20deep%20navy%20black%20and%20crimson%20tones%2C%20eerie%20flickering%20light%2C%20ominous%20atmosphere%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-002&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20old%20apartment%20corridor%20at%20midnight%2C%20single%20flickering%20ceiling%20lamp%2C%20deep%20navy%20shadows%2C%20creepy%20atmospheric%20lighting%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-002&orientation=landscape',
    views: 203100,
    favorites: 15870,
    featured: true,
  },
  {
    id: 'm-003',
    title: '末班地铁',
    year: 2024,
    duration: 96,
    category: '剧情',
    tags: ['城市', '孤独', '相遇'],
    director: '顾青芜',
    cast: ['温以宁', '黎望', '陈述'],
    rating: 8.5,
    synopsis: '每晚末班地铁上，两个失眠的陌生人靠着一节车厢的距离，慢慢拼凑出彼此破碎的生活。',
    midnightReason: '如果你也睡不着，这会是最温柔的一次陪伴，安静得刚刚好。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20lone%20figure%20in%20an%20empty%20subway%20car%20at%20night%2C%20deep%20navy%20and%20warm%20amber%20highlights%2C%20melancholic%20moody%20atmosphere%2C%20soft%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-003&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20inside%20an%20empty%20subway%20car%20at%20midnight%2C%20warm%20amber%20interior%20lights%2C%20deep%20navy%20night%20outside%20windows%2C%20melancholic%20moody%20lighting%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-003&orientation=landscape',
    views: 187300,
    favorites: 13240,
    featured: true,
  },
  {
    id: 'm-004',
    title: '雨夜标本馆',
    year: 2022,
    duration: 112,
    category: '悬疑',
    tags: ['雨夜', '博物馆', '失踪'],
    director: '邢北',
    cast: ['陆云归', '蒋星禾', '任迟'],
    rating: 8.0,
    synopsis: '一场暴雨把观众困在标本馆里，而馆藏的每一具标本，似乎都在指向十年前那桩没有结论的失踪案。',
    midnightReason: '窗外下着雨的时候打开它，雨声、脚步声和心跳声会重叠在一起。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20mystery%20movie%20poster%20of%20a%20dark%20natural%20history%20museum%20hall%20at%20night%2C%20deep%20navy%20and%20crimson%20tones%2C%20rain%20streaked%20windows%2C%20suspenseful%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-004&orientation=portrait',
    views: 96500,
    favorites: 7210,
  },
  {
    id: 'm-005',
    title: '黑水灯塔',
    year: 2023,
    duration: 124,
    category: '恐怖',
    tags: ['孤岛', '灯塔', '深海'],
    director: '沈墨',
    cast: ['傅舟', '叶知秋', '罗砚'],
    rating: 8.4,
    synopsis: '守塔人换班的第一夜，海上漂来一艘没有船员的船，而灯塔的光，照出了一个不该存在的轮廓。',
    midnightReason: '把灯关掉看，屏幕的光就是这座灯塔，你会分不清是它在看你，还是你在看它。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20poster%20of%20a%20lonely%20lighthouse%20on%20a%20rocky%20island%20at%20night%2C%20deep%20navy%20sea%20and%20crimson%20beam%2C%20dread%20filled%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-005&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20stormy%20sea%20with%20a%20lighthouse%20beam%20cutting%20the%20darkness%20at%20midnight%2C%20deep%20navy%20and%20crimson%20tones%2C%20dread%20filled%20atmospheric%20lighting%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-005&orientation=landscape',
    views: 176200,
    favorites: 14980,
    featured: true,
  },
  {
    id: 'm-006',
    title: '凌晨四点便利店',
    year: 2024,
    duration: 88,
    category: '剧情',
    tags: ['便利店', '夜班', '群像'],
    director: '顾青芜',
    cast: ['安然', '卫斯', '彭小满'],
    rating: 8.6,
    synopsis: '一家 24 小时便利店的监控录像，记录下四个凌晨四点发生在不同人身上的小事，它们悄悄连成了一条线。',
    midnightReason: '短小、温暖、不折腾，适合睡前最后一小时，看完心里会亮一盏灯。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20a%20glowing%2024%20hour%20convenience%20store%20at%20night%2C%20warm%20amber%20glow%20against%20deep%20navy%20dark%20street%2C%20quiet%20lonely%20atmosphere%2C%20soft%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-006&orientation=portrait',
    views: 142900,
    favorites: 11030,
  },
  {
    id: 'm-007',
    title: '回声公寓',
    year: 2021,
    duration: 101,
    category: '悬疑',
    tags: ['心理', '时间循环', '密室'],
    director: '白峒',
    cast: ['秦让', '尹枝', '杜行舟'],
    rating: 7.9,
    synopsis: '同一个夜晚，同一个房间，男人醒来十三次，每一次都有一件家具被挪动了位置，直到房间开始变得陌生。',
    midnightReason: '循环、重复、似曾相识，凌晨时看会怀疑自己是不是也重启过一次。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20psychological%20suspense%20movie%20poster%20of%20a%20dim%20furnished%20apartment%20room%20at%20night%2C%20deep%20navy%20and%20crimson%20tones%2C%20unsettling%20atmosphere%2C%20dramatic%20side%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-007&orientation=portrait',
    views: 88300,
    favorites: 6540,
  },
  {
    id: 'm-008',
    title: '无声来电',
    year: 2022,
    duration: 109,
    category: '恐怖',
    tags: ['电话', '诅咒', '都市传说'],
    director: '邢北',
    cast: ['夏引', '顾言溪', '邵川'],
    rating: 7.8,
    synopsis: '凌晨手机响起，接通后没有声音，只有缓慢的呼吸。挂断的人会在第七天收到第二通电话。',
    midnightReason: '把手机调成震动放在枕边，它每震一次，你就多一分信它可能是真的。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20poster%20of%20a%20glowing%20smartphone%20screen%20in%20total%20darkness%20on%20a%20bed%2C%20deep%20navy%20black%20and%20crimson%20accent%2C%20terrifying%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-008&orientation=portrait',
    views: 119700,
    favorites: 9020,
  },
  {
    id: 'm-009',
    title: '北纬零度',
    year: 2020,
    duration: 132,
    category: '剧情',
    tags: ['公路', '旅途', '亲情'],
    director: '沈墨',
    cast: ['祁年', '白朴', '林时序'],
    rating: 8.3,
    synopsis: '一对多年不说话的父女，在一辆深夜出发的旧皮卡上，用两千公里的沉默完成了和解。',
    midnightReason: '长途夜行的画面配上路灯光斑，会让你想起某个很想打却没打的电话。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20road%20movie%20poster%20of%20an%20old%20pickup%20truck%20on%20an%20empty%20highway%20at%20night%2C%20deep%20navy%20sky%20and%20warm%20amber%20headlights%2C%20lonely%20moody%20atmosphere%2C%20soft%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-009&orientation=portrait',
    views: 132500,
    favorites: 9870,
  },
  {
    id: 'm-010',
    title: '镜中第七夜',
    year: 2023,
    duration: 99,
    category: '恐怖',
    tags: ['镜子', '民俗', '七夜'],
    director: '白峒',
    cast: ['尹枝', '罗砚', '许听澜'],
    rating: 8.1,
    synopsis: '民俗里说，连续七夜半夜对镜点烛，能看见你想见的人。她照做了，第四夜开始，镜里的人比她先动。',
    midnightReason: '零点之后再看，你经过镜子的时候大概会下意识地绕开一步。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20poster%20of%20an%20antique%20mirror%20lit%20by%20candlelight%20in%20a%20dark%20room%2C%20deep%20navy%20and%20crimson%20tones%2C%20creepy%20ritual%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-010&orientation=portrait',
    views: 158900,
    favorites: 12460,
  },
  {
    id: 'm-011',
    title: '打烊之后',
    year: 2021,
    duration: 92,
    category: '剧情',
    tags: ['餐馆', '深夜', '故乡'],
    director: '顾青芜',
    cast: ['彭小满', '黎望', '安然'],
    rating: 8.2,
    synopsis: '一家开在异乡的小饭馆，老板每晚打烊后都会给最后一个客人多做一道菜，那道菜叫“家”。',
    midnightReason: '有点饿的时候别看，它会让你想立刻煮一碗面，然后慢慢地把它吃完。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20a%20small%20late%20night%20restaurant%20with%20warm%20hanging%20lights%2C%20deep%20navy%20night%20outside%2C%20cozy%20nostalgic%20atmosphere%2C%20soft%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-011&orientation=portrait',
    views: 76400,
    favorites: 5890,
  },
  {
    id: 'm-012',
    title: '猎户座信号',
    year: 2024,
    duration: 141,
    category: '悬疑',
    tags: ['科幻', '观测站', '信号'],
    director: '邢北',
    cast: ['傅舟', '蒋星禾', '陈述'],
    rating: 8.8,
    synopsis: '高原天文台收到一段来自猎户座的重复信号，译码之后，它其实是这座观测站三天后的求救录音。',
    midnightReason: '对着星空看一段关于讯号与孤独的故事，凌晨的脑子最容易相信宇宙在回应你。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci%20fi%20suspense%20movie%20poster%20of%20a%20lone%20astronomer%20silhouette%20before%20a%20radio%20telescope%20under%20a%20starry%20night%20sky%2C%20deep%20navy%20and%20faint%20crimson%2C%20austere%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-012&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20high%20altitude%20observatory%20dome%20beneath%20a%20vast%20star%20filled%20night%20sky%2C%20deep%20navy%20tones%2C%20lonely%20atmospheric%20lighting%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-012&orientation=landscape',
    views: 214600,
    favorites: 18300,
    featured: true,
  },
  {
    id: 'm-013',
    title: '出租车司机不回家',
    year: 2020,
    duration: 115,
    category: '剧情',
    tags: ['城市', '夜班', '群像'],
    director: '沈墨',
    cast: ['程野', '卫斯', '夏引'],
    rating: 8.0,
    synopsis: '一个夜班司机的十二个小时，他载过的每个乘客，都在替他给过去的生活带一句话。',
    midnightReason: '和城市一起醒着的电影，看着看着，你会觉得窗外那条马路也属于你。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20a%20taxi%20cab%20window%20view%20of%20a%20rainy%20neon%20city%20at%20night%2C%20deep%20navy%20and%20crimson%20accents%2C%20lonely%20moody%20atmosphere%2C%20soft%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-013&orientation=portrait',
    views: 101200,
    favorites: 7780,
  },
  {
    id: 'm-014',
    title: '第八位房客',
    year: 2022,
    duration: 108,
    category: '悬疑',
    tags: ['旅馆', '密室', '身份'],
    director: '白峒',
    cast: ['秦让', '叶知秋', '杜行舟'],
    rating: 8.3,
    synopsis: '一栋只登记了七个人的山间旅馆，早晨的早餐桌上却摆了八副餐具，而没有人记得第八个人是谁。',
    midnightReason: '数人、核对、推翻，凌晨的安静最适合玩这种“谁是多余的”的游戏。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20mystery%20movie%20poster%20of%20a%20dim%20mountain%20inn%20dining%20room%20at%20night%20with%20eight%20place%20settings%2C%20deep%20navy%20and%20crimson%20tones%2C%20uneasy%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-014&orientation=portrait',
    views: 139800,
    favorites: 10710,
  },
  {
    id: 'm-015',
    title: '窗帘在动',
    year: 2023,
    duration: 94,
    category: '恐怖',
    tags: ['家', '窥视', '心理'],
    director: '邢北',
    cast: ['周未然', '顾言溪', '邵川'],
    rating: 8.0,
    synopsis: '她总在半夜醒来，看见卧室窗帘微微摆动，可窗户是关着的，而窗外是十一楼。',
    midnightReason: '看完你会想去检查一遍窗户，然后又不确定到底该不该拉上窗帘。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20poster%20of%20a%20billowing%20white%20curtain%20in%20a%20dark%20bedroom%20at%20night%2C%20deep%20navy%20shadows%20and%20crimson%20accent%2C%20creepy%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-015&orientation=portrait',
    views: 146300,
    favorites: 11540,
  },
  {
    id: 'm-016',
    title: '最后一场雪',
    year: 2019,
    duration: 137,
    category: '剧情',
    tags: ['冬天', '记忆', '告別'],
    director: '顾青芜',
    cast: ['温以宁', '祁年', '白朴'],
    rating: 8.7,
    synopsis: '一位老人守着即将拆除的老屋，等一场据说是这个城市最后会下的雪，也等一个不会回来的人。',
    midnightReason: '安静、缓慢、后劲足，适合凌晨一个人看完，然后允许自己沉默一会儿。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20an%20old%20man%20silhouette%20at%20a%20window%20watching%20snow%20fall%20at%20night%2C%20deep%20navy%20tones%20with%20soft%20warm%20light%2C%20melancholic%20atmosphere%2C%20soft%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-016&orientation=portrait',
    views: 121900,
    favorites: 10230,
  },
  {
    id: 'm-017',
    title: '通话记录',
    year: 2024,
    duration: 106,
    category: '悬疑',
    tags: ['罪案', '推理', '都市'],
    director: '沈墨',
    cast: ['陆云归', '任迟', '蒋星禾'],
    rating: 8.5,
    synopsis: '一份被彻底删除的通话记录，成了翻案的唯一钥匙，而恢复它的工程师发现，最后一通电话是打给他自己的。',
    midnightReason: '线索一条一条收紧，凌晨的困意会被彻底赶跑，然后你就通宵了。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20suspense%20movie%20poster%20of%20a%20forensic%20analyst%20lit%20by%20monitor%20glow%20in%20a%20dark%20room%2C%20deep%20navy%20and%20crimson%20tones%2C%20tense%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-017&orientation=portrait',
    views: 198700,
    favorites: 16120,
  },
  {
    id: 'm-018',
    title: '不要回头',
    year: 2021,
    duration: 97,
    category: '恐怖',
    tags: ['乡村', '民俗', '禁忌'],
    director: '白峒',
    cast: ['许听澜', '罗砚', '傅舟'],
    rating: 7.9,
    synopsis: '村里的老人说，走夜路时听见有人喊你名字，千万别回头。少年不信，于是他回头了。',
    midnightReason: '这是个关于“回头”的诅咒，而看恐怖片时，你总会在最怕的瞬间回头看看身后。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20poster%20of%20a%20young%20man%20standing%20on%20a%20foggy%20rural%20road%20at%20night%20about%20to%20turn%20around%2C%20deep%20navy%20and%20crimson%20tones%2C%20dread%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-018&orientation=portrait',
    views: 112600,
    favorites: 8430,
  },
  {
    id: 'm-019',
    title: '失眠者的来信',
    year: 2023,
    duration: 111,
    category: '剧情',
    tags: ['书信', '孤独', '治愈'],
    director: '邢北',
    cast: ['黎望', '安然', '彭小满'],
    rating: 8.4,
    synopsis: '两个从未谋面的失眠者开始互寄匿名信，他们约好永不见面，直到其中一个人搬到了另一个人楼下。',
    midnightReason: '写给深夜不睡的人的一封信，读到最后，你会想给某个人发条消息。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20handwritten%20letters%20and%20a%20dim%20desk%20lamp%20at%20night%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20quiet%20intimate%20atmosphere%2C%20soft%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-019&orientation=portrait',
    views: 134100,
    favorites: 11420,
  },
  {
    id: 'm-020',
    title: '十三号放映厅',
    year: 2022,
    duration: 103,
    category: '恐怖',
    tags: ['影院', '胶片', '诡异'],
    director: '沈墨',
    cast: ['夏引', '尹枝', '陈述'],
    rating: 8.2,
    synopsis: '一家老影院有个从不对外售票的十三号厅，直到某个雨夜，它的放映机自己转动了起来。',
    midnightReason: '在“看电影”的电影里看电影，凌晨的你会分不清银幕内外哪边才是真的。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20poster%20of%20an%20old%20empty%20cinema%20auditorium%20with%20a%20flickering%20projector%20beam%2C%20deep%20navy%20and%20crimson%20tones%2C%20eerie%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-020&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20empty%20vintage%20cinema%20with%20rows%20of%20red%20seats%20and%20a%20glowing%20screen%2C%20deep%20navy%20shadows%2C%20moody%20atmospheric%20lighting%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-020&orientation=landscape',
    views: 167500,
    favorites: 13560,
    featured: true,
  },
  {
    id: 'm-021',
    title: '雾中灯塔守夜人',
    year: 2018,
    duration: 128,
    category: '剧情',
    tags: ['海', '孤独', '坚守'],
    director: '顾青芜',
    cast: ['祁年', '傅舟', '温以宁'],
    rating: 8.1,
    synopsis: '在即将被自动化取代的灯塔上，最后一位守夜人决定用一年的时间，把海的声音全部录下来。',
    midnightReason: '海浪、风声、老式录音机的电流声，是天然的白噪音，安静到心里。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20an%20old%20lighthouse%20keeper%20silhouette%20against%20fog%20and%20sea%20at%20night%2C%20deep%20navy%20tones%2C%20lonely%20serene%20atmosphere%2C%20soft%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-021&orientation=portrait',
    views: 69900,
    favorites: 5320,
  },
  {
    id: 'm-022',
    title: '无名房间',
    year: 2024,
    duration: 100,
    category: '悬疑',
    tags: ['记忆', '实验', '反转'],
    director: '白峒',
    cast: ['杜行舟', '叶知秋', '秦让'],
    rating: 8.6,
    synopsis: '一间没有任何门窗的房间，五个人醒来后发现自己记得同一个人的面孔，却没有一个人能说出那是谁。',
    midnightReason: '从头猜到尾，关于记忆和面孔的谜题，凌晨看会格外怀疑自己的记忆。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20mystery%20movie%20poster%20of%20a%20featureless%20empty%20white%20walled%20room%20lit%20harshly%20in%20darkness%2C%20deep%20navy%20and%20crimson%20accent%2C%20disorienting%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-022&orientation=portrait',
    views: 181400,
    favorites: 15210,
  },
  {
    id: 'm-023',
    title: '凌晨三点的敲门声',
    year: 2020,
    duration: 95,
    category: '恐怖',
    tags: ['独居', '敲门', '都市传说'],
    director: '邢北',
    cast: ['周未然', '邵川', '顾言溪'],
    rating: 7.7,
    synopsis: '独居女孩连续三晚在同一时间听见敲门声，猫眼里却空无一人，直到第四晚，门外站着的是她自己。',
    midnightReason: '如果你一个人住，建议开灯看；如果你不怕，那就关灯，反正它只在凌晨三点来。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20poster%20of%20an%20apartment%20door%20peephole%20view%20in%20darkness%20with%20a%20faint%20figure%2C%20deep%20navy%20and%20crimson%20tones%2C%20terrifying%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-023&orientation=portrait',
    views: 104800,
    favorites: 7960,
  },
  {
    id: 'm-024',
    title: '陪跑者',
    year: 2023,
    duration: 121,
    category: '剧情',
    tags: ['运动', '励志', '青春'],
    director: '沈墨',
    cast: ['甘棠', '黎望', '安然'],
    rating: 8.3,
    synopsis: '一个永远拿第二的马拉松选手，在退役前的最后一场比赛里，决定不再为任何人领跑。',
    midnightReason: '熬夜看完会有点想出门跑两步，至少会让你觉得明天还可以再努力一次。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20a%20runner%20training%20alone%20on%20an%20empty%20track%20at%20night%20under%20floodlights%2C%20deep%20navy%20and%20warm%20amber%20accents%2C%20determined%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-024&orientation=portrait',
    views: 118300,
    favorites: 9310,
  },
  {
    id: 'm-025',
    title: '深水旅馆',
    year: 2021,
    duration: 113,
    category: '悬疑',
    tags: ['湖泊', '旅馆', '失踪'],
    director: '邢北',
    cast: ['蒋星禾', '罗砚', '许听澜'],
    rating: 8.1,
    synopsis: '湖边旅馆每年都会在同一个夜晚封馆，住客说那晚湖底会亮起灯，而亮灯的人再也没有登记入住过。',
    midnightReason: '湖面、倒影、灯光，安静中慢慢渗出来的不安，最适合深夜独享。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20mystery%20movie%20poster%20of%20a%20lakeside%20motel%20reflected%20in%20dark%20still%20water%20at%20night%2C%20deep%20navy%20tones%20with%20crimson%20light%20underwater%2C%20eerie%20calm%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-025&orientation=portrait',
    views: 92700,
    favorites: 7010,
  },
  {
    id: 'm-026',
    title: '午夜出租车',
    year: 2024,
    duration: 92,
    category: '恐怖',
    tags: ['都市传说', '乘客', '公路'],
    director: '白峒',
    cast: ['程野', '夏引', '任迟'],
    rating: 7.8,
    synopsis: '夜班司机接到一位地址不存在的女乘客，而每一晚，她都在同一个路口上车，说着同一句“往前开”。',
    midnightReason: '城市夜路 + 诡异乘客，如果你也常在深夜打车，代入感会强到离谱。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20poster%20of%20a%20city%20taxi%20at%20night%20with%20a%20pale%20passenger%20silhouette%20in%20the%20back%20seat%2C%20deep%20navy%20and%20crimson%20tones%2C%20creepy%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-026&orientation=portrait',
    views: 132900,
    favorites: 10140,
  },
  {
    id: 'm-027',
    title: '旧照片修复师',
    year: 2022,
    duration: 126,
    category: '剧情',
    tags: ['记忆', '手艺', '温情'],
    director: '顾青芜',
    cast: ['白朴', '温以宁', '彭小满'],
    rating: 8.5,
    synopsis: '一位修复老照片的手艺人，每修好一张，就会听见照片里那个人的一段往事，直到他翻出一张自己的童年照。',
    midnightReason: '关于记忆和告别，节奏缓慢，适合凌晨安安静静地眼泪流一点。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20hands%20restoring%20faded%20photographs%20under%20a%20dim%20desk%20lamp%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20intimate%20nostalgic%20atmosphere%2C%20soft%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-027&orientation=portrait',
    views: 87300,
    favorites: 7420,
  },
  {
    id: 'm-028',
    title: '备份人生',
    year: 2024,
    duration: 119,
    category: '悬疑',
    tags: ['科幻', '身份', '反转'],
    director: '沈墨',
    cast: ['杜行舟', '傅舟', '尹枝'],
    rating: 8.7,
    synopsis: '一项“人生备份”服务能让你在意外后恢复记忆，直到有人发现，恢复回来的自己，其实和原来不是同一个人。',
    midnightReason: '关于“我还是不是我”的午夜拷问，凌晨的大脑最容易钻进去出不来。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci%20fi%20suspense%20movie%20poster%20of%20a%20reflective%20human%20silhouette%20facing%20a%20glowing%20data%20core%20in%20darkness%2C%20deep%20navy%20and%20crimson%20tones%2C%20cold%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-028&orientation=portrait',
    views: 209800,
    favorites: 17640,
  },
  {
    id: 'm-029',
    title: '梦游者之屋',
    year: 2020,
    duration: 105,
    category: '恐怖',
    tags: ['梦境', '老宅', '心理'],
    director: '白峒',
    cast: ['秦让', '周未然', '叶知秋'],
    rating: 7.9,
    synopsis: '搬进老宅的一家人发现，小女儿每晚都会梦游到地下室，而她画的那些“梦里的人”，正陆续出现在现实中。',
    midnightReason: '梦与现实的边界在凌晨最模糊，看完你会犹豫今晚要不要早点睡。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20poster%20of%20a%20child%20standing%20in%20a%20dark%20basement%20doorway%20at%20night%2C%20deep%20navy%20shadows%20and%20crimson%20accent%2C%20unsettling%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-029&orientation=portrait',
    views: 98600,
    favorites: 7190,
  },
  {
    id: 'm-030',
    title: '第七封信',
    year: 2023,
    duration: 133,
    category: '剧情',
    tags: ['悬疑', '书信', '救赎'],
    director: '邢北',
    cast: ['陆云归', '任迟', '安然'],
    rating: 8.8,
    synopsis: '丈夫离世后，妻子每周收到一封他生前写好的信，第七封信揭开的，却是一段她从未参与过的人生。',
    midnightReason: '悬念与温情各占一半，最后一封信会在凌晨两点精准击中你。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20a%20woman%20reading%20a%20letter%20by%20window%20light%20at%20night%2C%20deep%20navy%20tones%20with%20warm%20amber%20glow%2C%20emotional%20quiet%20atmosphere%2C%20soft%20lighting%2C%20minimal%20design%2C%20no%20text&width=600&height=900&seq=movie-poster-030&orientation=portrait',
    views: 156400,
    favorites: 13870,
  },
];